module.exports = __webpack_public_path__ + "img/app-store-badge.ab8d4e0a.svg";